import React from 'react';
import PropTypes from 'prop-types';

class LiveEventModalEmbed extends React.Component{

    render() {
        return (
            <div className="tab-panel">
                <div className="column column-wide">
                    <h6>Insert this code on the live event page:</h6>
                    <code>
                        {`<div class="live-event" data-live_event_id="${this.props.eventKey}"></div>`}
                    </code>
                </div>
            </div>
        );
    }
}

LiveEventModalEmbed.propTypes = {
    event: PropTypes.object.isRequired,
    eventKey: PropTypes.string.isRequired
}

export default LiveEventModalEmbed;


/** WEBPACK FOOTER **
 ** ./src/components/LiveEventModalEmbed.js
 **/